export default __webpack_public_path__ + "static/media/not_found.3985264b.svg";